import { cn } from '@/shared/utils/cn';
import type { ReactNode } from 'react';

interface HorizontalScrollRowProps {
  children: ReactNode;
  className?: string;
}

export function HorizontalScrollRow({ children, className }: HorizontalScrollRowProps) {
  return (
    <div
      className={cn(
        'flex min-w-0 gap-3 overflow-x-auto overflow-y-hidden pb-2',
        '[scrollbar-width:thin] [-ms-overflow-style:auto]',
        className
      )}
    >
      {children}
    </div>
  );
}
